import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createStore } from "vuex";
import { storeOptions } from "@moderrotech/servers-communication-library/src/store";
import { i18n } from "@/lang";
/* eslint-disable */
// @ts-ignore
import VueClipboard from 'vue3-clipboard'
/* eslint-enable */
import { metadataModule } from "@/store";
import _ from "lodash";
import { setValidationMessages } from "@/validation/locales";
import { defineRule, configure } from "vee-validate";
import * as rules from "@vee-validate/rules";
import { AVPlugin } from "vue-audio-visual";
import { initUaParser } from "@moderrotech/servers-communication-library/src/helpers/device";

const store = createStore(storeOptions);
store.registerModule("metadata", metadataModule);

store.dispatch("log/listenConsole");

// Make the validation aggressive to show case validators
configure({
  validateOnInput: true
});

// Install all rules
_.keys(rules).forEach(rule => {
  /* eslint-disable */
    // @ts-ignore
    if (typeof rules[rule] === 'function') {
        // @ts-ignore
        defineRule(rule, rules[rule]);
    }
    /* eslint-enable */
});

defineRule("phone", (value: string) => !value || /^\+\d{8,15}$/.test(value));

const idLetters = "TRWAGMYFPDXBNJZSQVHLCKET";

defineRule("dni", (value: string) => {
  if (!value) {
    return true;
  }
  if (!/^\d{8}[a-zA-Z]$/.test(value)) {
    return false;
  }
  return (
    value.slice(-1).toUpperCase() ===
    idLetters.substr(+value.slice(0, -1) % 23, 1)
  );
});

defineRule("nie", (value: string) => {
  if (!value) {
    return true;
  }
  if (!/^[xXyY]\d{7}[a-zA-Z]$/.test(value)) {
    return false;
  }
  return (
    value.slice(-1).toUpperCase() ===
    idLetters.substr(
      +`${value.slice(0, 1).toUpperCase() === "Y" ? "1" : ""}${value.slice(
        1,
        -1
      )}` % 23,
      1
    )
  );
});

setValidationMessages().finally(async () => {
  await initUaParser();

  createApp(App)
    .use(store)
    .use(router)
    .use(i18n)
    .use(VueClipboard, {
      autoSetContainer: true,
      appendToBody: true
    })
    .use(AVPlugin)
    .mount("#app");
});
